<script>
    import geoData from '../data/conus.json';
    import { geoPath, geoAlbersUsa } from 'd3-geo';
    let { data, box, loadedData, bounds } = $props();
    // import { geoAlbersUsa } from 'd3-geo-projection';

    let width = $state(0);
    let height = $state(0);
    let projection = $derived(geoAlbersUsa().fitSize([width, height], geoData));
    let path = $derived(geoPath(projection));
    let features = $derived(loadedData?.features || []);

    // Convert bounds to GeoJSON Feature with clipping logic
    const boundsToGeoJSON = (bounds) => {
        if (!bounds || !bounds._ne || !bounds._sw) return null;
        
        const { _ne, _sw } = bounds;
        
        // Define CONUS bounds (approximate contiguous US extent)
        const US_BOUNDS = {
            minLng: -125.0,
            maxLng: -66.9,
            minLat: 24.5,
            maxLat: 49.4
        };
        
        // Check if bounds are completely outside the US
        const isCompletelyOutside = 
            _ne.lng < US_BOUNDS.minLng || // completely west
            _sw.lng > US_BOUNDS.maxLng || // completely east
            _ne.lat < US_BOUNDS.minLat || // completely south
            _sw.lat > US_BOUNDS.maxLat;   // completely north
        
        if (isCompletelyOutside) {
            return null; // Don't show anything
        }
        
        // Clip the bounds to US extent
        const clippedBounds = {
            sw: {
                lng: Math.max(_sw.lng, US_BOUNDS.minLng),
                lat: Math.max(_sw.lat, US_BOUNDS.minLat)
            },
            ne: {
                lng: Math.min(_ne.lng, US_BOUNDS.maxLng),
                lat: Math.min(_ne.lat, US_BOUNDS.maxLat)
            }
        };
        
        return {
            type: "Feature",
            properties: {},
            geometry: {
                type: "Polygon",
                coordinates: [[
                    [clippedBounds.sw.lng, clippedBounds.sw.lat], // Southwest corner
                    [clippedBounds.sw.lng, clippedBounds.ne.lat], // Northwest corner
                    [clippedBounds.ne.lng, clippedBounds.ne.lat], // Northeast corner
                    [clippedBounds.ne.lng, clippedBounds.sw.lat], // Southeast corner
                    [clippedBounds.sw.lng, clippedBounds.sw.lat]  // Close the polygon
                ]]
            }
        };
    };

    let boundsGeoJSON = $derived(boundsToGeoJSON(bounds));


</script>
<div class='locator' bind:clientWidth={width} bind:clientHeight={height}>
    <svg width={width} height={height}>
        {#if path}
        <path d={path(geoData)} fill="none" stroke="#ffffff" stroke-width="4" opacity="1"/>
        <path d={path(geoData)} fill="#ffffff" stroke="#999999" stroke-width="0.5"/>
            {#if loadedData}
                {#each features.filter(feature => feature.properties.CATEGORY !== 'TSTM') as feature}
                    <path d={path(feature)} fill={feature.properties.fill} stroke="#ffffff" stroke-width="0"/>
                {/each}
            {/if}
            <!-- {#if boundsGeoJSON}
                <path d={path(boundsGeoJSON)} fill="none" stroke="#999999" stroke-width="0.5" />
            {/if} -->
            <path d={path(geoData)} fill="none" stroke="#999999" stroke-width="1"/>
        {/if}
    </svg>
</div>


<style lang='scss'>
.locator {
    width: 150px;
    height:90px;
    svg {
        overflow: visible;
    }
    
}
</style>